export default "__VITE_ASSET__f22f64ae__"